import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class WooTabs extends kr.Component {
    init() {
        this.$ = window.jQuery;
        this.ajax_url = window.ajax_url;
        this.$tabs = this.$element.querySelectorAll('div[data-tab]');
        this.$details = document.getElementById('customer_details');
        this.state = 'checkout_shippment';
        this.checking = false;
        this.messages = [];
        this.fieldsToValidate = {
            billing_first_name: {
                empty: false
            },
            billing_last_name: {
                empty: false
            },
            vat_number: {
                empty: true, method: '_validNip'
            },
            billing_address_1: {
                empty: false
            },
            billing_postcode: {
                empty: false, minLength: 3
            },
            billing_city: {
                empty: false
            },
            billing_phone: {
                empty: false, minLength: 9, method: '_validPhone'
            },
            billing_email: {
                empty: false, method: '_validEmail'
            },
        }

        this.bind();
    }

    bind() {
        this.on('click', 'a[data-change-tab]', async (target, event) => {
            event.preventDefault();
            this._removeMessages();
            if (this.checking) {
                return;
            }
            this.checking = true;
            HTMLClass.addClass(target, 'button--disabled');
            const check = await this._validForm();
            if (this.state == 'checkout_shippment' && !check) {
                this._showError();
                this.checking = false;
                HTMLClass.removeClass(target, 'button--disabled');
                return false;
            }
            this.checking = false;
            HTMLClass.removeClass(target, 'button--disabled');
            this._toggle(target);
        });

        this.$(function ($) {
            $('form[name="checkout"').keypress(function (e) {
                if (e.which == 13) {
                    return false;
                }
            });

            $('form[name="checkout"').on('checkout_place_order', () => {
               window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
               });
            });

            $('body').on('checkout_error', () => {
                $( 'html, body' ).stop();
            });
        });
    }

    _toggle(target) {
        const name = target.getAttribute('data-change-tab');
        if (typeof name === 'undefined' || !name) {
            return false;
        }

        if (name == 'checkout_shippment' && this.state == 'checkout_shippment') {
            window.location.href = target.getAttribute('data-carturl');
            return false;
        }

        const oldEl = document.querySelector(`div[data-wooicontab="${this.state}"]`);
        HTMLClass.removeClass(oldEl, 'cart__icon--active');
 
        this.state = name;
        const newEl = document.querySelector(`div[data-wooicontab="${this.state}"]`);
        HTMLClass.addClass(newEl, 'cart__icon--active');

        if (this.state == 'checkout_payment') {
            HTMLClass.addClass(this.$element, 'js-showPlaceOrder');
        } else {
            HTMLClass.removeClass(this.$element, 'js-showPlaceOrder');
        }

        this.$tabs.forEach(item => {
            if (item.getAttribute('data-tab') == name) {
                HTMLClass.addClass(item, 'tabs__content__item--active');
            } else {
                HTMLClass.removeClass(item, 'tabs__content__item--active');
            }
        });
    }

    async _validForm()
    {
        let valid = true;

        for (let i in this.fieldsToValidate) {
            const data = this.fieldsToValidate[i];
            const $el = document.getElementById(i);
            if (!$el) {
                continue;
            }

            const value = $el.value;
            const minLength = data.minLength | 1;
            if (!data.empty && (!value || value.length < minLength)) {
                this.messages.push(i);
                valid = false;
                continue;
            }
            if (value && typeof data.method !== 'undefined') {
                if (!await this[data.method](value)) {
                    this.messages.push(i);
                    valid = false;
                    continue;
                }
            }
        }
        return valid;
    }

    _showError(message = 'text')
    {
        const div = document.createElement('div');
        HTMLClass.addClass(div, 'checkout__input__error');
        HTMLClass.addClass(div, 'js-checkoutInputError');

        let html = `<p>${window.wc_checkout_params.i18n_checkout_error}</p>`;

        let ul = `<p>`;
        for (let i in this.messages) {
            const forr = this.messages[i];
            const label = document.querySelector(`label[for="${forr}"]`).innerHTML;
            ul+=`${label}<br>`;
        }
        ul+=`</p>`;
        html+=ul;
        div.innerHTML = html;
        this.$details.prepend(div);
        window.scrollTo({
            top: (this.$details.offsetTop - 300),
            behavior: 'smooth',
        });
    }

    _removeMessages()
    {
        const $el = document.querySelector('.js-checkoutInputError');
        if (!$el) {
            return;
        }
        $el.parentNode.removeChild($el);
        this.messages = [];
    }

    async _validNip(nip)
    {
        const data = {
            action: 'validNip',
            nip: nip,
            country: document.getElementById('billing_country').value
        }
        const response = await this.$.post(this.ajax_url, data);
        const result = JSON.parse(response);
        return result.success;
    }

    _validEmail(data)
    {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(data).toLowerCase());
    }

    _validPhone(data)
    {
        const re = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
        data = data.replaceAll(' ', '').replaceAll('+', '');
        return re.test(String(data).toLowerCase());
    }
}

kr.registerComponent('.js-wooTabs', {
    component: WooTabs
});